import type { FaireProductEntity } from "../../entity_types/product";

export const p_2mjsexwxr8: FaireProductEntity = {
  token: "p_2mjsexwxr8",
  type: "product",
  name: "Ravioli Pasta Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/bf78eb511ed174d3fd1160fdc59f42903f27c571eb5f3e06a4436fc438b3ba1b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/303471667a5f6c17d1acb32ca0fe846dfb2a1d40ac0592b72559c831112db3af.jpeg",
    "https://cdn.faire.com/fastly/864172314ea68d774768ec76da3eb7b3dd9ebd85e2f8e1c362be539db6479570.jpeg"
  ],
  priceDollars: 4,
  description: "For when your to-do list is more “al dente” than complete. These pasta sticky notes are here to help you noodle through your tasks.\n\nGood to know: \n\n * Stick & restick anywhere. \n * Measures 3in x 3in \n * 100% Recyclable \n\n",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:07.152Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
